import logo from '../assets/images/telsim-logo-rose-white.png';

function Header() {
    return (

        <nav className="navbar navbar-expand-lg ">
            <div className="container">
                <a className="navbar-brand" href="https://www.telsim.com.au/">
                    <img
                        src={logo}
                        alt="Logo"
                        className="d-inline-block align-top"
                    />
                </a>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon" />
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto">
                        <li className="nav-item">
                            <a className="nav-link" href="https://www.telsim.com.au/">
                                Home
                            </a>
                        </li>
                        <li className="nav-item dropdown">
                            <a className="nav-link dropbtn" href="#">
                                Shop &nbsp;<i className="fa fa-caret-down" />
                            </a>
                            <div className="dropdown-content">
                                <a href="https://www.telsim.com.au/sim-cards/">Sim Cards</a>
                                <a href="#AdressSelectBox">Home Internet</a>
                                <a href="https://www.telsim.com.au/esim-australia/">eSIM</a>
                                <a href="https://www.telsim.com.au/esim-international/">
                                    eSIM International
                                </a>
                                <a href="https://www.telsim.com.au/refurbished-mobile-phones/">
                                    Refurbished Mobiles
                                </a>
                                <a href="https://www.telsim.com.au/watches/">Watches</a>
                            </div>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="https://www.telsim.com.au/about-us/">
                                About Us
                            </a>
                        </li>

                        <li className="nav-item">
                            <a
                                className="nav-link nav-btn"
                                href="https://prepaid.telsim.com.au/"
                            >
                                NBN<sup>&reg;</sup> My Account
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className="nav-link nav-btn"
                                href="https://www.telsim.com.au/contact-us/"
                            >
                                Contact Us
                            </a>
                        </li>

                    </ul>
                </div>
            </div>
        </nav>


    );
}

export default Header;
